import React, { useCallback, useState, type ReactElement } from 'react';

import { Link } from '@pushwoosh/dumb-components';
import { Horizontal } from '@pushwoosh/kit-helpers';

import { H1 } from '~/src/ui-kit';
import { useEnvironment } from '~/src/contexts/environment';
import { Lang, useLang } from '~/src/polyglot';

import { AccountsList } from './components/AccountsList';
import { AccountsSelect } from './components/AccountsSelect';
import { StyledContentBox } from './styles';
import type { SelectAccountProps } from './SelectAccount.types';

const ACCOUNTS_COUNT_FOR_SELECT_VIEW = 4;

export function SelectAccount({
  accountsList,
  errorMessage,
  isLoading,
  selectHandler,
}: SelectAccountProps): ReactElement {
  const { getLinkByName } = useEnvironment();
  const lang = useLang();
  const [isSubmitting, setSubmitting] = useState<number | null>(null);

  const onAccountClick = useCallback(async (uid: number, methods: string[], method: string) => {
    if (isSubmitting) {
      return;
    }

    setSubmitting(uid);
    await selectHandler(uid, methods, method);
    setSubmitting(null);
  }, [setSubmitting, selectHandler, isSubmitting]);

  const ListComponent = accountsList.length > ACCOUNTS_COUNT_FOR_SELECT_VIEW
    ? AccountsSelect
    : AccountsList;

  return (
    <>
      <StyledContentBox>
        <H1><Lang message="SELECT_ACCOUNT.TITLE" /></H1>
        <ListComponent
          accountsList={accountsList}
          errorMessage={errorMessage}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          onAccountClick={onAccountClick}
        />
      </StyledContentBox>
      <Horizontal $alignItems="center">
        <Link title={lang({ message: 'SELECT_ACCOUNT.LOG_OUT' })} href={getLinkByName('login')}>
          <Lang message="SELECT_ACCOUNT.LOG_OUT" />
        </Link>
      </Horizontal>
    </>
  );
}
